export default __webpack_public_path__ + "static/soc2-28dccdef8df8d9eca7d39d34c9900ac4.png";